export const site = {
  name: 'Justin Perez',
  role: 'Software Engineer',
  // Kept short on purpose — this is the hero line, not a bio.
  tagline: 'I build security and platform tooling at scale.',
  intro:
    'Software engineer at NICE, working on distributed retrieval and event-driven services. I gravitate to the unglamorous parts — the sync jobs, the migrations, the access-control bugs — because that is usually where the real problems are hiding.',
  // Résumé-only positioning line. Leads with scope and ownership because the
  // target is senior roles — the reader needs to know how to read the bullets.
  resumeSummary:
    'Platform and full-stack engineer who owns systems end to end — federated retrieval in Python, event-driven .NET services, and the OIDC/SSO surface of a multi-tenant SaaS platform. I write the architecture decision record, drive it to consensus, and carry it to production across nine environments.',
  location: 'Salt Lake City, Utah',
  email: 'justinprz12@gmail.com',
  resume: 'Justin_Perez_Resume.pdf',
  socials: [
    { label: 'GitHub', href: 'https://github.com/JustinPerez12', icon: 'github' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/justindperez/', icon: 'linkedin' },
    { label: 'Email', href: 'mailto:justinprz12@gmail.com', icon: 'mail' },
  ],
}

export const navLinks = [
  { id: 'top', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'work', label: 'Work' },
  { id: 'skills', label: 'Skills' },
  { id: 'contact', label: 'Contact' },
]
